
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'bouncerate'
    })
  } // computed
}; // export default
